import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../common/store/generic.selectors';
import { ClaimTypeModel, claimTypeFeatureKey } from './types';
import { IClaimTypeState } from './claim-type.reducer';

const claimTypeFeatureState =
  createFeatureSelector<IClaimTypeState>(claimTypeFeatureKey);

export const claimTypeSelectors = {
  getById: createApiCallSelectors<ClaimTypeModel, IClaimTypeState>(
    claimTypeFeatureState,
    'getById',
  ),
  createInstance: createApiCallSelectors<ClaimTypeModel, IClaimTypeState>(
    claimTypeFeatureState,
    'createInstance',
  ),
  add: createApiCallSelectors<ClaimTypeModel, IClaimTypeState>(
    claimTypeFeatureState,
    'add',
  ),
  update: createApiCallSelectors<ClaimTypeModel, IClaimTypeState>(
    claimTypeFeatureState,
    'update',
  ),
  delete: createApiCallSelectors<boolean, IClaimTypeState>(
    claimTypeFeatureState,
    'delete',
  ),
};
